import { render, staticRenderFns } from "./PinUserToAnotherBranch.vue?vue&type=template&id=65023d23"
import script from "./PinUserToAnotherBranch.vue?vue&type=script&lang=js"
export * from "./PinUserToAnotherBranch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports